import {stateCodeMapping as stateCodeMappingMX} from '@app/components/forms/state-options-mexico'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Transforms a state's conventional abbreviation to its official code for Mexico, or returns the original abbreviation for other countries.
 * @param {string} countryCode - The ISO country code (e.g., 'MX' for Mexico).
 * @param {string} conventionalAbbreviation - The conventional state abbreviation to transform.
 * @returns {string} The official state code for Mexico if applicable, otherwise the original abbreviation.
 */
export const transformStateCode = function (countryCode, conventionalAbbreviation) {
    if (countryCode !== 'MX') return conventionalAbbreviation
    return stateCodeMappingMX[conventionalAbbreviation] || conventionalAbbreviation
}

/**
 * Determines if a given country code is blacklisted for Google Address Autocomplete.
 * @param {string} countryCode - The ISO country code to check against the blacklist.
 * @returns {boolean} True if the country code is blacklisted for Google Autocomplete, false otherwise.
 */
export const isCountryBlacklistedForGoogleAutocomplete = function (countryCode) {
    const {app: appConfig} = getConfig()
    const googleBlacklistedCountries =
        appConfig?.GOOGLE_ADDRESS_AUTOCOMPLETE_BLACKLISTED_COUNTRIES?.split(',') || []
    return countryCode && googleBlacklistedCountries.includes(countryCode)
}
